import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

const SignaturePreview = ({ signatureTemplate, formData }) => {
  const [isVisible, setIsVisible] = useState(false);

  // Générer la signature avec les données actuelles du formulaire
  const generatePreviewSignature = () => {
    let preview = signatureTemplate;
    
    // Remplacer les placeholders par les vraies valeurs ou des valeurs par défaut
    preview = preview.replace(/\$\{formData\.nom\}/g, formData.nom || '[Nom]');
    preview = preview.replace(/\$\{formData\.prenom\}/g, formData.prenom || '[Prénom]');
    preview = preview.replace(/\$\{formData\.fonction\}/g, formData.fonction || '[Fonction]');
    preview = preview.replace(/\$\{formData\.telephone\}/g, formData.telephone || '[Téléphone]');
    preview = preview.replace(/\$\{formData\.adresse1\}/g, formData.adresse1 || '[Adresse 1]');
    preview = preview.replace(/\$\{formData\.adresse2\}/g, formData.adresse2 || '[Adresse 2]');
    preview = preview.replace(/\$\{formData\.codePostal\}/g, formData.codePostal || '[Code postal]');
    preview = preview.replace(/\$\{formData\.ville\}/g, formData.ville || '[Ville]');
    
    return preview;
  };

  if (!isVisible) {
    return (
      <div className="mt-6">
        <button
          type="button"
          onClick={() => setIsVisible(true)}
          className="flex items-center space-x-2 text-sm text-blue-600 hover:text-blue-800 transition-colors"
        >
          <Eye size={16} />
          <span>Afficher la prévisualisation de la signature</span>
        </button>
      </div>
    );
  }

  return (
    <div className="mt-6 p-4 bg-gray-50 border border-gray-200 rounded-lg">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-gray-900">Prévisualisation de la signature</h3>
        <button
          type="button"
          onClick={() => setIsVisible(false)}
          className="flex items-center space-x-2 text-sm text-gray-600 hover:text-gray-800 transition-colors"
        >
          <EyeOff size={16} />
          <span>Masquer</span>
        </button>
      </div>
      
      <div className="bg-white p-4 border border-gray-300 rounded-md">
        <div 
          dangerouslySetInnerHTML={{ __html: generatePreviewSignature() }}
          className="signature-preview"
          style={{ fontFamily: 'Arial, sans-serif' }}
        />
      </div>
      
      <p className="text-xs text-gray-500 mt-2">
        Cette prévisualisation se met à jour automatiquement quand vous modifiez les informations du formulaire.
      </p>
    </div>
  );
};

export default SignaturePreview; 